// extracted by mini-css-extract-plugin
export default {"container":"Splash_container__CtbA0","logo":"Splash_logo__l1pjR","pulse":"Splash_pulse__3VZqv"};